import { render, staticRenderFns } from "./description-tab.vue?vue&type=template&id=6b79f4c8"
import script from "./description-tab.vue?vue&type=script&lang=js"
export * from "./description-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports